<template>
  <div
    :class="{
      'uss-persona-edu-intent container mt-6': true,
    }"
  >
    <h2>
      {{ personaGeneralTitle }}
    </h2>
    <p
      :class="{
        'mb-4 text-center text-xs leading-7 text-www-color-neutral-medium-dark md:text-15px': true,
      }"
    >
      {{ personaGeneralSubtitle }}
    </p>
    <p
      :class="{
        'mb-25px mt-12 text-center text-xs text-www-color-neutral-medium-dark md:text-lg': true,
      }"
    >
      {{ PersonaListSubTitle }}
    </p>
    <UssPersonaEduList
      :personas="eduList"
      :selected-value="selectedEduLevel"
      @select="onSelectEduLevel"
    />

    <slot />
    <template v-if="screenPartialData?.sectionBuilder?.length > 0">
      <component
        :is="getComponent(component._type)"
        v-for="component in screenPartialData?.sectionBuilder"
        :key="component._key"
        :value="component"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UssPersonaEduList from '~/components/Atmos/SignUpPartials/UssPersonaEduIntent/UssPersonaEduList.vue';
import { getComponent } from '~/components/Mapper';
import type PersonaEduConvergeSignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/PersonaEduConvergeSignupScreen';
import UnifiedSignupPersona from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupPersona';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type { SignupPartialViewsSectionBuilder, UssPersonaEduConverge } from '~/sanity/types';

const { signupScreen, sessionInfo } = defineProps<
  UssPersonaEduConverge & {
    signupScreen: PersonaEduConvergeSignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
    screenPartialData: SignupPartialViewsSectionBuilder;
  }
>();

const eduLevelField = signupScreen.getField(FieldHtmlNameUtil.eduLevel);
const ageVerificationField = signupScreen.getField(FieldHtmlNameUtil.ageVerification);
const persona = sessionInfo.persona;
const selectedEduLevel = ref<string>(eduLevelField.val as string);

const onSelectEduLevel = (value: string) => {
  selectedEduLevel.value = value;
  eduLevelField.val = value;
};

// Watch for K-12 to show age verification
watch(
  selectedEduLevel,
  (eduLevel) => {
    if (`${eduLevel}`.includes('K-12') && persona?.compareTo(UnifiedSignupPersona.studentPerson)) {
      ageVerificationField.componentName = ageVerificationField.initialComponentName;
      ageVerificationField.val = '';
    } else {
      ageVerificationField.val = 'overage';
      ageVerificationField.componentName = 'hidden-field';
    }
  },
  { immediate: true }
);
</script>

<style></style>
